import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import { Link } from "react-router-dom"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"

let appService = null
let plasticsUser = null
let staffService = new Staff()

const Reviewed = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [permissions, setpermissions] = useState()
  const [reviewed, setreviewed] = useState()

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    plasticsUser = appService.getStrategy("head")
    plasticsUser.getReviewedApplications(1).then(response => {
      if (response.status) {
        setreviewed(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    plasticsUser.getReviewedApplications(page).then(response => {
      if (response.status) {
        setreviewed(response.data)
      }
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Reviewed | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Reviewed</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    All applications reviewed by Officers will show up here.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <Applications
                viewOnly={true}
                user={user}
                data={reviewed}
                paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Reviewed
